import {h} from 'preact';

function Radio(props) {
    const correct = props.correct || undefined;
    const selectStyle = (checked, correct) => {
        const baseClassName = 'aQuizAnswer__Label';
        const prefix = baseClassName + ' ' + baseClassName;

        if (correct === null) {
            return baseClassName;
        }
        if (checked && correct) {
            return prefix + '--true';
        } else if (checked && !correct) {
            return prefix + '--false';
        } else if (correct && !checked) {
            return prefix + '--correct';
        } else {
            return baseClassName;
        }
    }

    return (
        <span>
            <input id={props.id} type="radio" onInput={props.onInput} name={props.name} checked={props.checked} value={props.id} disabled={props.disabled}/>
            <label htmlFor={props.id} className={selectStyle(props.checked, correct)}>{props.label}</label>
        </span>
    )
}

export default Radio
